import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/services/auth.service';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CommonInterceptorInterceptor } from './interceptors/common-interceptor.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ToastService } from './shared/toast.service';
import { EmbedSessionState } from './shared/embed-session.state';

function appInitializer(authService: AuthService) {
  return () => {
    // The embedded editor is opened from another application by someone with no Templatify
    // user: it authenticates with its editing session, never with Keycloak.
    if (EmbedSessionState.isEmbedPath(window.location.pathname)) return Promise.resolve();
    return new Promise((resolve) => {
      //@ts-ignores
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    ClipboardModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    SweetAlert2Module.forRoot(),
    NgxSpinnerModule,
  ],
  providers: [
    // Roomgrid toasts: every ToastrService injection site gets the shared toast (same look as KeyLink/Notify).
    { provide: ToastrService, useExisting: ToastService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CommonInterceptorInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
